import {
    FETCH_DRIVER_PARTNERS_REQUEST,
    FETCH_DRIVER_PARTNERS_SUCCESS,
    FETCH_DRIVER_PARTNERS_FAILURE,
    UPDATE_DRIVER_PARTNER_STATUS_REQUEST,
    UPDATE_DRIVER_PARTNER_STATUS_SUCCESS,
    UPDATE_DRIVER_PARTNER_STATUS_FAILURE,
} from "../actions/types";

const initialState = {
    driverPartners: [],
    total: 0,
    page: 1,
    size: 10,
    pages: 0,
    loading: false,
    error: null,
    message: "",
};

export default function driverPartnerReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_DRIVER_PARTNERS_REQUEST:
        case UPDATE_DRIVER_PARTNER_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_DRIVER_PARTNERS_SUCCESS:
            return {
                ...state,
                loading: false,
                driverPartners:
                    action.payload.data || [],
                total:
                    action.payload.total || 0,
                page:
                    action.payload.page || 1,
                size:
                    action.payload.size || 10,
                pages:
                    action.payload.pages || 0,
                message:
                    "Driver Partners loaded successfully",
            };

        case FETCH_DRIVER_PARTNERS_FAILURE:
        case UPDATE_DRIVER_PARTNER_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case UPDATE_DRIVER_PARTNER_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                driverPartners:
                    state.driverPartners.map(
                        (partner) =>
                            partner
                                .driver_partner
                                .driver_partner_id ===
                            action.payload.driver_partner_id
                                ? {
                                      ...partner,
                                      driver_partner:
                                          {
                                              ...partner.driver_partner,
                                              ...action.payload,
                                          },
                                  }
                                : partner
                    ),
                message:
                    "Driver Partner status updated successfully",
            };

        default:
            return state;
    }
}